/**
 * This is a copy-paste from src/core/models/sdg-themes.data.ts in the iackathon project.
 */

export const SDG_THEMES = [
  {
    name: 'pas de pauvreté',
    slug: 'poverty',
    description: 'sdg-theme.poverty-description',
    icon: 'sdg_theme_no_poverty',
    color: '#E5243B',
  },
  {
    name: 'faim "zéro"',
    slug: 'hungry',
    description: 'sdg-theme.hungry-description',
    icon: 'sdg_theme_zero_hunger',
    color: '#DEA73D',
  },
  {
    name: 'bonne santé et bien-être',
    slug: 'health',
    description: 'sdg-theme.health-description',
    icon: 'sdg_theme_health',
    color: '#4D9F3A',
  },
  {
    name: 'éducation de qualité',
    slug: 'education',
    description: 'sdg-theme.education-description',
    icon: 'sdg_theme_education',
    color: '#C5192D',
  },
  {
    name: 'égalité entre les sexes',
    slug: 'sexe-equality',
    description: 'sdg-theme.sexe-equality-description',
    icon: 'sdg_theme_gender_equality',
    color: '#FF3A21',
  },
  {
    name: 'eau propre et assainissement',
    slug: 'water',
    description: 'sdg-theme.water-description',
    icon: 'sdg_theme_clean_water',
    color: '#2CBDE3',
  },
  {
    name: "énergie propre et d'un coût abordable",
    slug: 'power',
    description: 'sdg-theme.power-description',
    icon: 'sdg_theme_clean_energy',
    color: '#FDC40E',
  },
  {
    name: 'travail décent et croissance économique',
    slug: 'work',
    description: 'sdg-theme.work-description',
    icon: 'sdg_theme_economic_growth',
    color: '#A31A43',
  },
  {
    name: 'industrie, innovation et infrastructure',
    slug: 'innovation',
    description: 'sdg-theme.innovation-description',
    icon: 'sdg_theme_industry',
    color: '#FE6926',
  },
  {
    name: 'inégalités réduites',
    slug: 'inequality',
    description: 'sdg-theme.inequality-description',
    icon: 'sdg_theme_reduced_inequalities',
    color: '#DD1367',
  },
  {
    name: 'villes et communautés durables',
    slug: 'urban',
    description: 'sdg-theme.urban-description',
    icon: 'sdg_theme_sustainable_cities',
    color: '#FE9D26',
  },
  {
    name: 'consommation et production responsables',
    slug: 'consume',
    description: 'sdg-theme.consume-description',
    icon: 'sdg_theme_resposible_consumption',
    color: '#BF8B2E',
  },
  {
    name: 'lutte contre les changements climatiques',
    slug: 'climate',
    description: 'sdg-theme.climate-description',
    icon: 'sdg_theme_climate_action',
    color: '#3F7E44',
  },
  {
    name: 'vie aquatique',
    slug: 'aquatic-life',
    description: 'sdg-theme.aquatic-life-description',
    icon: 'sdg_theme_life_below_water',
    color: '#099AD9',
  },
  {
    name: 'vie terrestre',
    slug: 'terrestrial-life',
    description: 'sdg-theme.terrestrial-life-description',
    icon: 'sdg_theme_life_on_land',
    color: '#58C02E',
  },
  {
    name: 'paix, justice et institutions efficaces',
    slug: 'peace',
    description: 'sdg-theme.peace-description',
    icon: 'sdg_theme_peace_justice',
    color: '#03689D',
  },
  {
    name: 'partenariats pour la réalisation des objectifs',
    slug: 'partners',
    description: 'sdg-theme.partners-description',
    icon: 'sdg_theme_partnerships',
    color: '#19486A',
  },
] as const;

export type SdgTheme = (typeof SDG_THEMES)[number];
